/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AirtimeFeesDto } from './airtimeFeesDto';


export interface AirtimeDeviceCalculationSimpleDto { 
    id?: number;
    insertTs?: string;
    deviceId?: number;
    fees?: AirtimeFeesDto;
    bytes?: number;
    inclusiveBytes?: number;
    startDate?: string;
    endDate?: string;
    currency?: AirtimeDeviceCalculationSimpleDto.CurrencyEnum;
    numberOfConnections?: number;
}
export namespace AirtimeDeviceCalculationSimpleDto {
    export const CurrencyEnum = {
        Usd: 'USD',
        Eur: 'EUR',
        Cad: 'CAD'
    } as const;
    export type CurrencyEnum = typeof CurrencyEnum[keyof typeof CurrencyEnum];
}


export type CurrencyEnum = typeof AirtimeDeviceCalculationSimpleDto.CurrencyEnum[keyof typeof AirtimeDeviceCalculationSimpleDto.CurrencyEnum];
